import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { rxStompServiceFactory,RxStompService } from "@stomp/ng2-stompjs";
import { RxStompState,RxStompConfig } from "@stomp/rx-stomp";
import * as SockJS from "sockjs-client";
import { environment } from "src/environments/environment";

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgWsProcessorService {
    rxStompService:RxStompService;
    subscriptionConnection:any;
    
    constructor(
        public http:HttpClient
    ) {
        
    }

    getApiUrlBase(){
        let url = environment.websocket.processor.protocol;
        url += `://${environment.websocket.processor.host}`;
        url += `:${environment.websocket.processor.port}`;
        url += `/${environment.websocket.processor.websocketEndPoing}`;
        return url;
    }

    getApiUrlServer2Client(){
        let url = `/${environment.websocket.processor.server2client}`;
        return url;
    }

    getApiUrlClient2Server(){
        let url = `/${environment.websocket.processor.client2server}`;
        return url;
    }

    initStomp(){
        let _this = this;
        let stompConfig:RxStompConfig = new RxStompConfig();
        stompConfig.reconnectDelay = 0;
        stompConfig.webSocketFactory = function(){
            return new SockJS(_this.getApiUrlBase());
        }
        stompConfig.debug = function(msg:string){
            //console.log("stompConfig",msg);
        };
        this.rxStompService = rxStompServiceFactory(stompConfig);
        this.rxStompService.configure(stompConfig);

        // let promise = new Promise((resolve,reject) => {
        //     try{

        //     }catch(ex){

        //     }
        // });
    }

    disconnect(){
        try{
            // console.log("disconnect",this.rxStompService);
            if(this.rxStompService){
                this.subscriptionConnection.unsubscribe();
                this.rxStompService.deactivate();
                // console.log("disconnect","deactivate",this.rxStompService);
            }
        }catch(ex){
            console.error("FvmsApiDtgWsProcessorService","disconnect",ex);
        }
    }

    connect(){
        try{
            this.disconnect();
            this.initStomp();
            let self = this;
            this.subscriptionConnection = this.rxStompService.connectionState$
                .subscribe((state) => {
                    // console.log("rxStompService","status",RxStompState[state]);
                    switch(state){
                        case RxStompState.OPEN:
                            self.rxStompService.activate();
                            break;
                        case RxStompState.CONNECTING:
                        case RxStompState.CLOSING:
                        case RxStompState.CLOSED:
                        default:
                            break;
                    }
                },
                () => {
                    self.disconnect();
                });
            return this.rxStompService.connectionState$;
        }catch(ex){
            console.error("FvmsApiDtgWsProcessorService","connect",ex);
            this.disconnect();
        }
    }

    subscribePacketLog(){
        let url = this.getApiUrlServer2Client();
        url += "/packetLog/inbound";
        return this.rxStompService.watch(url);
        // this.rxStompService.watch(url).subscribe((serverMessage:Message) => {
        //     console.log("FvmsWebsocketService","subscribePacketLog","VCI_LOG",serverMessage);
        // });
    }
}